import * as React from 'react';
import { Route, Switch } from 'react-router-dom';

import PersonalinfoList from './personalinfo-list.component';
import PersonalinfoCreate from './personalinfo-create.component';
import PersonalinfoView from './personalinfo-view.component';
import PersonalinfoEdit from './personalinfo-edit.component';
import PersonalinfoCopy from './personalinfo-copy.component';
import PersonalinfoDelete from './personalinfo-delete.component';

interface Props {
  root?: string;
}

export const PersonalinfoRouteEmployee: React.FunctionComponent<Props> = (props) => {

  return (
    <Switch>
      <Route path={`${props.root||''}/employee/create`} render={(params) => <PersonalinfoCreate {...params} key={params.history.location.key} caption='Create Employee' personalinfotypeType='employee' />} />    
      <Route path={`${props.root||''}/employee/view`} render={(params) => <PersonalinfoView {...params} key={params.history.location.key} root={props.root} caption='View Employee' personalinfotypeType='employee' />} />        
      <Route path={`${props.root||''}/employee/edit`} render={(params) => <PersonalinfoEdit {...params} key={params.history.location.key} root={props.root} caption='Edit Employee' personalinfotypeType='employee' />} />        
      <Route path={`${props.root||''}/employee/copy`} render={(params) => <PersonalinfoCopy {...params} key={params.history.location.key} caption='Duplicate Employee' personalinfotypeType='employee' />} />     
      <Route path={`${props.root||''}/employee/delete`} render={(params) => <PersonalinfoDelete {...params} key={params.history.location.key} root={props.root} caption='Delete Employee'/>} />        
      <Route path={(props.root||'') + '/employee'} render={(params) => <PersonalinfoList {...params} key={params.history.location.key} root={props.root} caption='Employee' personalinfotypeType='employee' />} /> 
    </Switch>
  );
}
